export function useCmsMode<T extends Record<string, unknown>>(props: T) {
  const editMode = useEditMode()
  const model = toRef(editMode ? useVModelProps(props) : props)

  return {
    model,
    editMode,
  }
}
